import { useTranslation } from 'next-i18next';

import { useIsSSR, useRouter } from '@boss/hooks';
import { ColorButton } from '@boss/ui';

import { useColorByColorId } from '../../../client-queries';
import { useContactPermissions, useFavorites } from '../../../hooks';

type Props = {
  id: string;
  slug: string;
  onClickAction?: 'navigate' | 'click';
};

const CfColorButton = ({ id, slug, onClickAction }: Props) => {
  const { data: color, isLoading } = useColorByColorId(id);
  const { favorites, toggleFavorite } = useFavorites();
  const { t } = useTranslation();
  const isSSR = useIsSSR();
  const { locale } = useRouter();
  // [39787] Non-cumulative heart rule: hide only when BOTH permissions are false; fail-open.
  const { showprice = true, canorder = true } = useContactPermissions(locale) ?? {};
  const hideHeart = showprice === false && canorder === false;

  if (isSSR) {
    return null;
  }

  return (
    <ColorButton
      {...color}
      backgroundColor={color?.rgb ?? ''}
      id={color?.code}
      isFavorite={favorites?.COLORS?.includes(color?.code ?? '')}
      loading={isLoading}
      onClickAction={onClickAction}
      onFavorite={hideHeart ? undefined : () => toggleFavorite('COLORS', color?.code ?? '', color)}
      slug={slug}
      translations={{ trending: t('trending') ?? '' }}
      variant="secondary"
    />
  );
};

export default CfColorButton;
